<template>
 <div class="d-flex h-100 justify-center overflow-hidden" :style="`background-color: ${isTargetShop ? '#FFA300' : $bgColor};border:${isTargetShop ? '#FFA300' : $bgColor} solid 1px;`">
  <img :src="imgCover" alt="imgCover" :class="$isTargetShop ? 'banner2' : 'banner'"  :style="`background-color: ${isTargetShop ? '#FFA300' : $bgColor};`"/>
 </div>
</template>

<style scoped>
.banner{
  position: absolute;
    -o-object-fit: contain;
    object-fit: contain;
    /* height: 250px; */
    width: 100%;
}
.banner2{
  /* position: absolute; */
    -o-object-fit: contain;
    object-fit: contain;
    /* height: 250px; */
    width: 100%;
}

.v-sheet.v-card {
    border-radius: 14px;
    background-color: white !important;
}
#primary {
  background-color: #181446;
}
</style>
<script>
export default {
  computed: {
    computedStyle () {
      return this.isTargetShop ? this.fontColorLMG : this.$textcolor
    },
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  components: {},
  props: {
    imgCover: {
      type: String,
      default: null
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Layouts/SectionBanner.vue